export default __webpack_public_path__ + "static/media/development.c1fa7426.PNG";